import axios, { AxiosResponse, CancelToken } from "axios";
import { tokenProviderFactory } from "azure-integration/tokenProvider";
import configProvider from "../config/configProvider";
import { apiScopes } from "./apiScopes";
import qs from "qs";

const get = async <TIn, T>(url: string, params?: TIn): Promise<T> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.get<T>(configProvider.API_URL + url, {
    headers,
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
  if (response.status >= 400) {
    throw new Error(`Error in GET: ${url}`);
  }
  return response.data;
};

const getBlob = async <TIn, T>(url: string, params?: TIn): Promise<T> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.get<T>(configProvider.API_URL + url, {
    headers,
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    responseType: 'blob'
  });
  if (response.status >= 400) {
    throw new Error(`Error in GET: ${url}`);
  }
  return response.data;
};

const post = async <TData, TResponse>(url: string, data?: TData, cancelToken?: CancelToken): Promise<TResponse> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.post<TData, AxiosResponse<TResponse>>(configProvider.API_URL + url, data, { headers, cancelToken });
  return response.data;
};

const postBlob = async <TData>(url: string, data?: TData): Promise<Blob> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.post(configProvider.API_URL + url, data, {
    headers,
    responseType: 'blob'
  });
  return response.data;
};

const put = async <TData, TResponse>(url: string, data?: TData): Promise<TResponse> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.put<TData, AxiosResponse<TResponse>>(configProvider.API_URL + url, data, { headers });
  return response.data;
};

const patch = async <TData, TResponse>(url: string, data?: TData): Promise<TResponse> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.patch<TData, AxiosResponse<TResponse>>(configProvider.API_URL + url, data, { headers });
  return response.data;
};

const remove = async <TData, TResponse>(url: string, data?: TData): Promise<TResponse> => {
  const headers = await tokenProviderFactory(apiScopes).getAuthHeaders();
  const response = await axios.delete<TData, AxiosResponse<TResponse>>(configProvider.API_URL + url, { headers });
  return response.data;
};

const apiClient = {
  get,
  getBlob,
  post,
  postBlob,
  put,
  patch,
  remove,
};

export default apiClient;
